module.exports = __webpack_public_path__ + "static/reel-0ea1c2fc0f405b53bf78c83c342562f5.mp4";